import { render, staticRenderFns } from "./TopMenuV2.vue?vue&type=template&id=8e8e3234&scoped=true"
import script from "./TopMenuV2.vue?vue&type=script&lang=js"
export * from "./TopMenuV2.vue?vue&type=script&lang=js"
import style0 from "./TopMenuV2.vue?vue&type=style&index=0&id=8e8e3234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8e3234",
  null
  
)


    import installComponents from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BImgLazy} from 'bootstrap-vue'
    installComponents(component, {BImgLazy})
    

export default component.exports